'use client';

import { useEffect } from 'react';
import { initGA4 } from '@/lib/analytics';

interface GoogleAnalyticsProps {
  measurementId: string;
}

/**
 * Client component that initializes GA4 tracking.
 * Renders nothing — side-effect only.
 */
export function GoogleAnalytics({ measurementId }: GoogleAnalyticsProps) {
  useEffect(() => {
    initGA4(measurementId);
  }, [measurementId]);

  return null;
}
